import { ErrorResponse, SeoContent } from '~shared/models';

export interface PlpSeoState {
  plpSEOContent: SeoContent;
  loading: boolean;
  error: ErrorResponse;
}

export const PlpSeoInitialState: PlpSeoState = {
  plpSEOContent: {
    active: false,
    introContent: '',
    advisoryContentTitle: '',
    advisoryContentDescription: '',
    otherContent: '[]',
    banners: [],
  },
  loading: false,
  error: null,
};
